import {createContext, type ReactNode, useContext, useEffect, useState} from 'react';

import {useAutoDeliveryDcxContext} from '../../../AutoDeliveryDcxContext';
import {useReschedulePopupFlow} from './hooks/useReschedulePopupFlow';

type RescheduleFlowContextValue = ReturnType<typeof useReschedulePopupFlow> & {
    isOpen: boolean;
    open: () => void;
};

const RescheduleFlowContext = createContext<RescheduleFlowContextValue | null>(null);

export const RescheduleFlowProvider = ({children}: {children: ReactNode}) => {
    const [isOpen, setIsOpen] = useState(false);
    const {rescheduleOpenTrigger, setRescheduleOpenTrigger} = useAutoDeliveryDcxContext();
    const flow = useReschedulePopupFlow({onClose: () => setIsOpen(false)});

    useEffect(() => {
        if (rescheduleOpenTrigger) {
            setRescheduleOpenTrigger(false);
            setIsOpen(true);
        }
    }, [rescheduleOpenTrigger, setRescheduleOpenTrigger]);

    const value = {
        ...flow,
        isOpen,
        open: () => setIsOpen(true),
    };

    return <RescheduleFlowContext.Provider value={value}>{children}</RescheduleFlowContext.Provider>;
};

export const useRescheduleFlow = (): RescheduleFlowContextValue => {
    const context = useContext(RescheduleFlowContext);

    if (!context) {
        throw new Error('useRescheduleFlow must be used within RescheduleFlowProvider');
    }

    return context;
};
